/* eslint-disable react/prop-types */
import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';

import { Header } from '@qality/common-components/src/atoms/Header';
import {
  Table,
  createColumnWidths,
  createColumnsWidths,
  createPredefinedColumnWidths,
} from '@qality/common-components/src/atoms/Table';
import { Issue } from '@qality/common-components/src/molecules/Issue';
import { CheckboxField } from '@qality/common-components/src/molecules/final-form/Checkbox';
import { FieldError } from '@qality/common-components/src/molecules/final-form/FieldError';
import { Issue as IssueModel } from '@qality/common-model';

import { SelectIssuesViewListWrapperStyled } from './SelectIssues.styled';

type Columns = 'checkbox' | 'key' | 'summary';

const ColumnsWidths = createColumnsWidths<Columns>({
  checkbox: createPredefinedColumnWidths('checkbox'),
  key: createColumnWidths('240px'),
  summary: createColumnWidths(),
});

type Props = {
  isAllChecked: boolean;
  onSelectAll: (e: React.ChangeEvent<HTMLInputElement>) => void;
  issues: Array<IssueModel>;
  fields: any;
};

export default function SelectIssuesView({
  isAllChecked,
  onSelectAll,
  issues,
  fields,
}: Props): JSX.Element {
  return (
    <>
      <Header spacing='medium'>Select Issues</Header>
      <SelectIssuesViewListWrapperStyled>
        <Table addStickyHeader>
          <Table.Head>
            <Table.Tr>
              <Table.CheckboxTh widths={ColumnsWidths.checkbox}>
                <Table.ContentHelper height='compact' alignItems='center'>
                  <Checkbox isChecked={isAllChecked} onChange={onSelectAll} />
                </Table.ContentHelper>
              </Table.CheckboxTh>
              <Table.Th widths={ColumnsWidths.key}>Key</Table.Th>
              <Table.Th widths={ColumnsWidths.summary}>Summary</Table.Th>
            </Table.Tr>
          </Table.Head>

          <Table.Body>
            {fields.map((issue, index) => {
              return (
                <Table.Tr key={issue} isHoverable>
                  <Table.CheckboxTd>
                    <Table.ContentHelper
                      justifyContent='center'
                      alignItems='center'
                    >
                      <CheckboxField
                        isChecked={issues[index].isChecked}
                        name={`${issue}.isChecked`}
                      />
                    </Table.ContentHelper>
                  </Table.CheckboxTd>
                  <Table.Td>
                    <Issue
                      issueKey={issues[index].key}
                      issueLink={issues[index].issueLink}
                      addPadding
                    />
                  </Table.Td>
                  <Table.Td>
                    <Issue
                      title={issues[index].fields.summary}
                      issueLink={issues[index].issueLink}
                      addPadding
                    />
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Body>
        </Table>
      </SelectIssuesViewListWrapperStyled>
      <FieldError name='selectedIssues' />
    </>
  );
}
